export class OpenWindowError extends Error {
    constructor(message = "") {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
